export type DialogHiddenState = {
    hidden: boolean,
    transition: boolean,
};

export enum DialogType {
    OFFCANVAS = 'offcanvas',
    MODAL = 'modal'
}
export enum OffcanvasPosition {
    OFFCANVAS_START = 'offcanvas-start',
    OFFCANVAS_END = 'offcanvas-end',
    OFFCANVAS_TOP = 'offcanvas-top',
    OFFCANVAS_BOTTOM = 'offcanvas-bottom'
}

export enum SimpleModalType {
    SUCCESS = 'success',
    ERROR = 'error',
    CONFIRM = 'confirm',
    INFO = 'info',
}
